import { useEffect, useState } from "react";
import apiClient from "@/services/apiClient";

export function useUpcomingCourses(campusId = "all") {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const fetchCourses = async () => {
      try {
        setLoading(true);
        setError("");

        const apiBaseUrl = process.env.REACT_APP_API_URL;
        const selectedCampusId = campusId === "all" ? 0 : campusId;
        const url = `${apiBaseUrl}/Course/GetUpcomingCourses?pCampusId=${encodeURIComponent(selectedCampusId)}`;

        const response = await apiClient.get(url);

        if (!isMounted) return;

        const payload = response.data;
        const normalized = Array.isArray(payload)
          ? payload
          : payload && typeof payload === "object"
            ? [payload]
            : [];

        setCourses(normalized);
      } catch (err) {
        console.error("Failed to load upcoming courses", err);
        if (isMounted) {
          setCourses([]);
          setError("Unable to load upcoming classes right now.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchCourses();

    return () => {
      isMounted = false;
    };
  }, [campusId]);

  return { courses, loading, error };
}
